import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

var AuthContext = createContext(null);

export function AuthProvider(props) {
  var savedUser = localStorage.getItem('okc_user');
  var initial = savedUser ? JSON.parse(savedUser) : null;
  var us = useState(initial);
  var user = us[0], setUser = us[1];
  var ls = useState(!initial);
  var loading = ls[0], setLoading = ls[1];

  useEffect(function() {
    var token = localStorage.getItem('okc_token');
    if (token) {
      authAPI.me()
        .then(function(res) {
          var u = res.data.data;
          setUser(u);
          localStorage.setItem('okc_user', JSON.stringify(u));
        })
        .catch(function() {
          localStorage.removeItem('okc_token');
          localStorage.removeItem('okc_user');
          setUser(null);
        })
        .finally(function() { setLoading(false); });
    } else {
      setLoading(false);
    }
  }, []);

  var login = function(email, password) {
    return authAPI.login(email, password).then(function(res) {
      var data = res.data.data;
      if (data.requires_2fa) {
        return { requires_2fa: true, user_id: data.user_id };
      }
      localStorage.setItem('okc_token', data.token);
      localStorage.setItem('okc_user', JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    });
  };

  var logout = function() {
    localStorage.removeItem('okc_token');
    localStorage.removeItem('okc_user');
    setUser(null);
  };

  return React.createElement(AuthContext.Provider,
    { value: { user: user, login: login, logout: logout, loading: loading } },
    props.children
  );
}

export function useAuth() { return useContext(AuthContext); }
